export function backendApartmentPath(wpBookingSlug: string) {
  return `https://thedepositseedhouse.com/wp-accommodation/${wpBookingSlug}/#reserve`;
}

export function money(value: number | undefined) {
  if (typeof value !== "number") {
    return "Ask";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}
